export default __webpack_public_path__ + "static/media/70t.da48b662.jpg";